import React from 'react';
import {
  Text,
  Image,
  ListItem,
  Stack,
  Box,
  VStack,
  Container,
  Flex,
  useBreakpointValue,
  OrderedList,

} from '@chakra-ui/react';

import HomeLayout from '../../components/layouts/homelayout';
import HeroWithRightMedia from '../../components/sections/herowithrightmedia'
import HeroWithLeftMedia from '../../components/sections/herowithleftmedia';
import TextBox from '../../components/sections/textbox';

import InclusionDiversityHero from '../../components/ui/ourcompany/S18-Montrail-TK-1187-copy-crop1651x903.png'
import InclusionDiversitySelfie from '../../components/ui/ourcompany/S19_CAS_BR_OR_0068-copy.jpeg'
import GertImg from '../../components/ui/ourcompany/gert_boyle.jpeg'
import UpdatedDiversityMetrics from '../../components/ui/ourcompany/Updated-Diversity-Info-v3.png'

export default function StrategyMissionValues() {
  return (
    <HomeLayout align="left">
      <Stack w="full" pt="90px"></Stack>
      <Flex
        w={'full'}
        h={'40vh'}
        backgroundImage={InclusionDiversityHero}
        backgroundSize={'cover'}
        backgroundPosition={'center center'}
        id="strategyMissionValuesHeroImg"
      >
        <VStack
          w={'full'}
          justify={'end'}
          align={'left'}
          px={useBreakpointValue({ base: 4, md: 8 })}
          bgGradient={'linear(to-r, blackAlpha.600, transparent)'}
        >
          <Stack maxW={'2xl'} spacing={6}>
            <Text
              align="center"
              color={'white'}
              fontWeight={600}
              lineHeight={1.2}
              fontSize={useBreakpointValue({
                base: '2xl',
                md: '4xl',
                sm: '3xl',
              })}
              mb="10px"
              id="outdoorsisforeveryone"
            >
              THE OUTDOORS IS FOR EVERYONE
            </Text>
          </Stack>
        </VStack>
      </Flex>

      <HeroWithRightMedia
        title={
          <Box>
            <Text fontWeight={'bold'} mt="10px">
              INCLUSION, DIVERSITY & EQUITY
            </Text>
          </Box>
        }
        subTitle={
          <Text fontSize="xs" mb="4">
            The outdoors is diverse. In nature, different colors, shapes and
            species thrive due to their diversity. Diverse perspectives lead to
            creativity and innovation. Equity leads to empowerment. Inclusion
            leads to teamwork. We've grown from a family business to a global
            company because we understand what it takes to flourish. Since 1938,
            we have been making clothing and footwear so that more people can
            enjoy the outdoors. We connect active people with their passions
            across race, ethnicity, gender, ability, religion and sexual
            orientation. Doing the right thing for our consumers, customers,
            employees, the company and our communities is one of our core
            values. We are dedicated to creating a company that is diverse,
            equitable and inclusive because one thing that we can all agree on
            is the outdoors is for all of us.
          </Text>
        }
        media={<Image borderRadius={10} src={InclusionDiversitySelfie} />}
      />
      <HeroWithLeftMedia
        title={
          <Box>
            <Text fontWeight={'bold'} mt="10px">
              OUR HISTORY INFORMS OUR PRESENT
            </Text>
          </Box>
        }
        subTitle={
          <Text fontSize="xs" mb="4">
            Columbia Sportswear Company was founded by immigrants fleeing Nazi
            Germany. Their daughter, Gert Boyle, held every position, from
            seamstress of the first fishing vest to President and Chair of the
            Board. Ma Boyle was a pioneer as a woman in the outdoor industry.
            Her legacy continues to inspire us now that we are a global company
            with more than 7,000 employees all over the world.
          </Text>
        }
        media={<Image borderRadius={10} src={GertImg} />}
      />
      <Container maxW="6xl">
        <Image
          align="justify-center"
          borderRadius={10}
          height={760}
          width={1015}
          src={UpdatedDiversityMetrics}
        />
        <VStack align="left">
          <Text fontWeight={'bold'} fontSize="3xl" mt="10px" py={4}>
            RECENT STATEMENTS FROM COLUMBIA SPORTSWEAR COMPANY ON RACIAL
            INJUSTICE
          </Text>
        </VStack>
        <VStack align="center">
          <Text as="i" fontSize="sm">
            In a statement to Columbia Sportswear Company employees, Tim Boyle,
            President & CEO, shared the following: <br />
            <br />
            "We stand together with all victims of racism and all who speak out
            and act against racial injustice. But this is not just about those
            who hold leadership positions. We are all in a position to lead. I
            am reminded of the powerful words of Supreme Court Justice Thurgood
            Marshall: 'Where you see wrong or inequality or injustice, speak
            out, because this is your country. This is your democracy. Make it.
            Protect it. Pass it on.'
            <br />
            <br />
            Gert always drove relentless improvement by saying, 'It's perfect,
            now make it better.' On the topic of racism, society is more than
            imperfect, and we must all be relentless in the effort to make it
            better.”
          </Text>
          <OrderedList>
            <ListItem>
              We will make donations to the NAACP Legal Defense Fund and the
              Marshall Project to advance our country's understanding of racism
              and its root causes and to promote equal justice and opportunity
            </ListItem>
            <ListItem>
              We will follow the lead of our employees. When employees choose to
              make donations to 501[c]3 non-profits focused on addressing
              racism, we are offering to double match the contributions up to
              $1,000.
            </ListItem>
            <ListItem>
              We will help individuals and communities exercise the critical
              right to vote, along with others in our industry.
            </ListItem>
            <ListItem>
              We will continue to speak out and be a company that celebrates and
              encourages diversity.
            </ListItem>
            <ListItem>
              We are working to help end racial injustice. This includes the
              facilitation of education about racism within our own company,
              with ongoing events and dialogue.
            </ListItem>
          </OrderedList>
          <TextBox
            textArea={`George Floyd’s life mattered. Black lives matter.`}
          />
        </VStack>
      </Container>
    </HomeLayout>
  );
}
